/**
 * Sandbox Logs Tab
 *
 * Thin wrapper that composes useInstanceLogs + InstanceLogViewer in full-height mode.
 *
 * @module features/sandboxes/components/SandboxLogsTab
 */

import React from 'react';
import { useInstanceLogs } from '../../../hooks/useInstanceLogs';
import { InstanceLogViewer } from '../../../ui/components/InstanceLogViewer';

type SandboxLogsTabProps = {
  instanceId: string;
};

export const SandboxLogsTab: React.FC<SandboxLogsTabProps> = ({ instanceId }) => {
  const { state, isConnected, connect, disconnect, clearLogs } = useInstanceLogs(instanceId, {
    autoConnect: true,
  });

  return (
    <InstanceLogViewer
      variant="full"
      state={state}
      isConnected={isConnected}
      onConnect={connect}
      onDisconnect={disconnect}
      onClear={clearLogs}
      className="h-full"
    />
  );
};
